module.exports = __webpack_public_path__ + "static/img/pm2-logo-dark.1bc8720.png";